import React from 'react';
import { useLocation } from 'react-router-dom';
import { LegalNav } from './PrivacyPolicy';
import './LegalPage.css';

const AvisoLegal = () => {
  useLocation(); // needed to keep LegalNav reactive
  return (
    <div className="legal-page">
      <h1>Aviso legal</h1>
      <p className="legal-updated">Última actualización: octubre de 2026</p>
      <LegalNav />

      <h2>1. Datos identificativos</h2>
      <p>
        En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se informa de que los sitios <strong>almaley.com</strong> y <strong>app.almaley.com</strong> (en adelante, «Almaley») son titularidad de:
      </p>
      <ul>
        <li><strong>Titular:</strong> Eva Bravo Ruiz</li>
        <li><strong>NIF:</strong> 03874215A</li>
        <li><strong>Domicilio:</strong> Calle Maravillas, 24, Cabañas de la Sagra (Toledo)</li>
        <li><strong>Correo electrónico:</strong> <a href="mailto:legal@almaley.com">legal@almaley.com</a></li>
        <li><strong>Formulario de contacto:</strong> <a href="https://almaley.com/contacto/">almaley.com/contacto</a></li>
      </ul>

      <h2>2. Objeto</h2>
      <p>
        Almaley es una plataforma de preparación de oposiciones de la Administración de Justicia (Auxilio Judicial y Tramitación Procesal y Administrativa) que ofrece temarios, preguntas de examen, un asistente basado en inteligencia artificial y herramientas de repaso. La web pública almaley.com ofrece información sobre el servicio y sobre estas oposiciones.
      </p>

      <h2>3. Carácter no oficial</h2>
      <p>
        Almaley es un servicio privado e independiente. <strong>No es un organismo oficial ni está vinculado al Ministerio de Justicia ni a ningún tribunal calificador.</strong> La información publicada tiene carácter orientativo y no sustituye a las convocatorias, bases y normas publicadas en el Boletín Oficial del Estado y en los boletines oficiales correspondientes, que son la única fuente válida para plazos, requisitos y temarios vigentes.
      </p>

      <h2>4. Condiciones de uso</h2>
      <p>
        El acceso y uso del servicio se rige por los <a href="/legal/terminos">Términos y condiciones</a>. El usuario se compromete a hacer un uso adecuado de los contenidos y servicios y a no emplearlos para actividades ilícitas o contrarias a la buena fe.
      </p>

      <h2>5. Propiedad intelectual e industrial</h2>
      <p>
        Los textos legales del temario proceden de fuentes oficiales (BOE). El diseño, el software, la marca Almaley, los resúmenes, las explicaciones y demás contenido propio son titularidad de Almaley o de sus licenciantes y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o comunicación pública sin autorización expresa, salvo lo permitido por la ley.
      </p>

      <h2>6. Contenidos generados con IA y responsabilidad</h2>
      <p>
        Parte del contenido (resúmenes, preguntas, correcciones y respuestas del asistente) se genera con modelos de inteligencia artificial. Pese a los controles aplicados, puede contener errores o imprecisiones, por lo que debe contrastarse con el texto oficial de la norma. Almaley no responde de los daños derivados de un uso del contenido como única fuente de estudio ni de la falta de disponibilidad temporal del servicio.
      </p>

      <h2>7. Enlaces a terceros</h2>
      <p>
        Almaley puede incluir enlaces a sitios de terceros (por ejemplo, el BOE). No controlamos su contenido ni asumimos responsabilidad sobre él.
      </p>

      <h2>8. Protección de datos y cookies</h2>
      <p>
        El tratamiento de datos personales se describe en la <a href="/legal/privacidad">Política de privacidad</a> y el uso de cookies en la <a href="/legal/cookies">Política de cookies</a>.
      </p>

      <h2>9. Legislación aplicable</h2>
      <p>
        Este aviso se rige por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a la normativa aplicable, incluido el fuero imperativo que pueda corresponder a los consumidores y usuarios.
      </p>
    </div>
  );
};

export default AvisoLegal;
